import { BillingTerm } from 'api/models/Common/JyrneyEnums'
import * as yup from 'yup'

export default yup.object().shape({
  payment: yup.object().shape({
    accountHolderName: yup
      .string()
      .required()
      .label('Account holder / Company name'),
    accountNumber: yup.string().length(8).required().label('Account Number'),
    sortCode: yup.string().length(6).required().label('Sort Code'),
  }),
  billingTermTypeName: yup
    .string()
    .nullable()
    .oneOf([...Object.keys(BillingTerm)], 'Billing term is required')
    .label('Payment Term'),
  billingTermValue: yup
    .number()
    .when('billingTermTypeName', {
      is: 'DaysFromInvoice',
      then: yup
        .number()
        .typeError('Number of days is required')
        .min(0)
        .max(999)
        .required()
        .label('Number of Days'),
      otherwise: yup
        .number()
        .typeError('Number of days is required')
        .nullable(),
    })
    .label('Number of days'),
  vatRegistered: yup.boolean().label('VAT Registered'),
  address: yup
    .object()
    .shape({
      addressLine1: yup.string(),
      town: yup.string(),
      county: yup.string(),
      postCode: yup.string(),
      country: yup.string(),
      countryCode: yup.string(),
    })
    .required(),
})
